import '../elitePlansTheme.css'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID, ElitePlansLandingProvider, useElitePlansLanding } from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_PRIME_LANDING_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { ElitePlansSellLandingChrome } from '../components/ElitePlansSellLandingChrome'
import { ElitePrimeDashboardHeader } from '../components/ElitePrimeDashboardHeader'
import { ElitePlansSellBody } from '../components/ElitePlansSellBody'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePrimeLandingPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.PrimeLanding}
      lockedPlanId={ELITE_PLANS_ELITE_PRIME_TAB_ID}
      statusQueryKeyRoot={ELITE_PRIME_LANDING_STATUS_QUERY_KEY}
    >
      <ElitePrimeLandingPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePrimeLandingPageContent() {
  const { isStatusLoading } = useElitePlansLanding()
  useTrackElitePlansScreenLoadWhenReady(!isStatusLoading)

  return (
    <ElitePlansSellLandingChrome>
      <ElitePrimeDashboardHeader />
      <ElitePlansSellBody />
    </ElitePlansSellLandingChrome>
  )
}
